import styled from "styled-components";

const ZeCorrectText = styled.span`
  color: green;
`;

export default ZeCorrectText;
